module.exports = __webpack_public_path__ + "static/media/pause-circle.56317c9d.svg";